import React from "react";
import { createRoot } from "react-dom/client";
// ROOT APP
import App from "./app/App.jsx";

import "./styles/app/app.scss";
import "bootstrap-icons/font/bootstrap-icons.css";

const root = createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
